<div class="flex flex-row flex-wrap gap-2 justify-content-center">
    <h1 *ngIf="pageTexts && pageTexts['mainTitle']" class="m-1 text-center">
        {{ pageTexts['mainTitle'] }}
    </h1>
    <p *ngIf="pageTexts && pageTexts['mainText']" class="w-11 text-center m-0 mb-2">
        {{ pageTexts['mainText'] }}
    </p>
    <div *ngIf="filterType !== 'city' && filterType !== 'locality'" class="flex w-11 m-auto my-2 justify-content-center">
        <p-selectButton id="cities" [options]="cityFilters" optionLabel="name" optionValue="id" [(ngModel)]="selectedCity"
                [multiple]="false" (onOptionClick)="filterByCity($event)"></p-selectButton>
    </div>
    <p-dialog [(visible)]="showProfile" [modal]="true" [draggable]="false" styleClass="w-11"
        (onHide)="hideProfile()" [maximizable]="true" [dismissableMask]="true" [blockScroll]="true">
        <ng-template pTemplate="header">
            <h3></h3>
        </ng-template>
        <ng-template pTemplate="content">
            <app-profile [urlIdFromModal]="urlIdToDisplay"></app-profile>
        </ng-template>
    </p-dialog>
    <div class="flex flex-row flex-wrap gap-2 justify-content-center" >
        <div *ngFor="let person of personList; let i = index" class="w-11rem sm:w-15rem" (click)="openDialog(person.url_id)" style="cursor: pointer; min-height: 307px;">
            <a [routerLink]="getUrlProfile(person.url_id)" title="Perfil de escort prepago {{ person.name }}" ariaLabel="Perfil de escort prepago {{ person.name }}" ></a>
            <div pDefer>
                <ng-template>
                    <p-card [styleClass]="'shadow-2 hover:shadow-8 ' + subscriptionClass[person.subscriptionName!]" >
                        <ng-template pTemplate="header">
                            <div class="relative hover-link overflow-hidden">
                                <div *ngIf="person.subscriptionName !== 'Gratuito' && person.subscriptionName !== 'Clásico'" class="ribbon">{{person.subscriptionName}}</div>
                                <img ngSrc="{{ thumbnailLocation + person.file_name! }}" (onImageError)="handleError($event)"
                                    alt="'Imagen de perfil de escort prepago {{ person.name }}'" width="240" height="320.84" 
                                    class="list-image" [priority]="i < 15" />
                                <a class="m-1 absolute z-1 top-0 right-0 text-0" [routerLink]="getUrlProfile(person.url_id)">
                                    <span class="pi pi-external-link" style="font-size: 1.3rem"></span>
                                </a>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="content">
                            <div class="relative">
                                <div *ngIf="!person.activity" class="absolute flex flex-row gap-1 tags">
                                    <p-tag *ngIf="person.verified === 1" icon="pi pi-check" value="Verificado" styleClass="z-1"></p-tag>
                                    <p-tag *ngIf="isNew(person)" icon="pi pi-star-fill" value="Nuevo" severity="warning" styleClass="z-1"></p-tag>
                                    <p-tag *ngIf="isActive(person)" icon="pi pi-circle-fill" value="En línea" severity="success" styleClass="z-1"></p-tag>
                                </div>
                            </div>
                            <div *ngIf="!person.activity" class="flex flex-row justify-content-between align-items-center p-1">
                                <div class="flex flex-column">
                                    <span class="title">{{ person.name }}</span>
                                    <p class="m-0 p-0">{{ person.locality.name }}</p>
                                </div>
                                <span class="flex flex-column align-items-center"><p class="m-0 p-0 title">{{ person.age }}</p> años</span>
                            </div>
                            <div class="relative">
                                <div *ngIf="person.activity" class="activity-phrase w-full z-2">
                                    <p class="quote">"{{ person.activity.description }}"</p>
                                </div>
                            </div>
                        </ng-template>
                    </p-card>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="flex flex-row flex-wrap gap-2 justify-content-center" *ngIf="!ready">
        <div *ngFor="let person of emptyPersonList" class="w-11rem sm:w-15rem">
            <p-card styleClass="shadow-2">
                <ng-template pTemplate="header">
                    <div class="relative hover-link">
                        <p-skeleton height="235px" styleClass="p-1 m-1 w-full"></p-skeleton>
                    </div>
                </ng-template>
                <ng-template pTemplate="content">
                    <div class="flex flex-row justify-content-between align-items-center">
                        <div class="flex flex-column">
                            <p-skeleton height="2rem" styleClass="p-1 m-1 w-6rem"></p-skeleton>
                            <p-skeleton height="1rem" styleClass="p-1 m-1 w-4rem"></p-skeleton>
                        </div>
                        <p-skeleton height="4rem" styleClass="p-1 m-1 w-2rem"></p-skeleton>
                    </div>
                </ng-template>
            </p-card>
        </div>
    </div>
    <p *ngIf="personListAlternative.length > 0 && pageTexts && pageTexts['alternateText']" class="w-11 text-center my-4">
        {{ pageTexts['alternateText'] }}
    </p>
    <p *ngIf="personListAlternative.length > 0 && !pageTexts" class="w-11 text-center my-4">
        ¿Aún no encuentras a la escort de tu preferencia? Mira también Escorts y Prepagos en ubicaciones aledañas.
    </p>
    <div *ngFor="let person of personListAlternative" class="w-11rem sm:w-15rem" (click)="openDialog(person.url_id)" style="cursor: pointer;">
        <a [routerLink]="getUrlProfile(person.url_id)" title="Perfil de escort prepago {{ person.name }}" aria-label="Ir al perfil" ></a>
        <div pDefer>
            <ng-template>
                <p-card [styleClass]="'shadow-2 hover:shadow-8 ' + subscriptionClass[person.subscriptionName!]">
                    <ng-template pTemplate="header">
                        <div class="relative hover-link">
                            <div *ngIf="person.subscriptionName !== 'Gratuito' && person.subscriptionName !== 'Clásico'" class="ribbon">{{person.subscriptionName}}</div>
                            <img src="{{ thumbnailLocation + person.file_name! }}" (onImageError)="handleError($event)" 
                                alt="'Imagen de perfil de escort prepago {{ person.name }}'" width="240" />
                            <a class="m-1 absolute z-1 top-0 right-0 text-0" [routerLink]="getUrlProfile(person.url_id)">
                                <span class="pi pi-external-link" style="font-size: 1.3rem"></span>
                            </a>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div class="relative">
                            <div class="absolute flex flex-row gap-1 tags">
                                <p-tag *ngIf="person.verified === 1" icon="pi pi-check" value="Verificado" styleClass="m-1 absolute z-1 top-0 left-0"></p-tag>
                                <p-tag *ngIf="isNew(person)" icon="pi pi-star-fill" value="Nuevo" severity="warning" styleClass="z-1"></p-tag>
                                <p-tag *ngIf="isActive(person)" icon="pi pi-circle-fill" value="En línea" severity="success" styleClass="z-1"></p-tag>
                            </div>
                        </div>
                        <div class="flex flex-row justify-content-between align-items-center">
                            <div class="flex flex-column">
                                <span class="title">{{ person.name }}</span>
                                <p class="m-0 p-0">{{ person.locality.name }}</p>
                            </div>
                            <span class="flex flex-column align-items-center"><p class="m-0 p-0 title">{{ person.age }}</p> años</span>
                        </div>
                    </ng-template>
                </p-card>
            </ng-template>
        </div>
    </div>
    <div *ngIf="filterType === 'locality'" class="w-11">
        <p>Listado completo de 👉 
            <a [routerLink]="getCategoryUrl(currentCity?.searchName!)" class="link" title="Escorts en {{ currentCity?.name }}">
                Escorts en {{ currentCity?.name }}
            </a>
        </p>
    </div>
    <div *ngIf="categoryFilter" class="w-11">
        <h3 class="w-11 m-0">
            Más tipos de Escorts en Muy Complacientes 📌
        </h3>
        <div class="flex flex-row flex-wrap justify-content-around">
            <div>
                <h4>Por servicio</h4>
                <ul>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('baratas')" class="link" title="Escorts Baratas / Económicas">
                            Escorts Baratas / Económicas
                        </a>
                    </li>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('a-domicilio')" class="link" title="Escorts a Domicilio">
                            Escorts a Domicilio
                        </a>
                    </li>
                </ul>
            </div>
            <div>
                <h4>Por edad</h4>
                <ul>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('maduras')" class="link" title="Escorts Maduras">
                            Escorts Maduras
                        </a>
                    </li>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('universitarias')" class="link" title="Escorts Universitarias">
                            Escorts Universitarias
                        </a>
                    </li>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('18-anos')" class="link" title="Escorts 18 años">
                            Escorts 18 años
                        </a>
                    </li>
                </ul>
            </div>
            <div>
                <h4>Por características</h4>
                <ul>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('tetonas')" class="link" title="Escorts Tetonas">
                            Escorts Tetonas
                        </a>
                    </li>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('gorditas')" class="link" title="Escorts Gorditas">
                            Escorts Gorditas
                        </a>
                    </li>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('morenas')" class="link" title="Escorts Morenas">
                            Escorts Morenas
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <h2 *ngIf="pageTexts && pageTexts['secondaryTitle']" class="w-11 m-0">
        {{ pageTexts['secondaryTitle'] }}
    </h2>
    <p *ngIf="pageTexts && pageTexts['secondaryText']" class="w-11 text-justify m-1">
        {{ pageTexts['secondaryText'] }}
    </p>
    <div class="flex flex-column w-11 m-0" *ngIf="filterType === 'time' || filterType === 'activity'">
        <p [innerHTML]="pageTexts['secondaryHtml']"></p>
    </div>
    <div class="flex flex-column w-11 m-0" *ngIf="filterType === 'escorts'">
        <div *ngFor="let city of cities">
            <h3>
                <a [routerLink]="city.searchName" class="link" title="Escorts en {{city.name}}">Prepagos y Escorts {{ city.name }}</a>
            </h3>
            <div class="w-10 align-items-center m-auto">
                <ul class="listado">
                    <li *ngFor="let locality of allLocalities[city.searchName]" class="my-3">
                        <a [routerLink]="city.searchName + '/' + getLocalityUrl(locality)!" class="link" title="Escorts en {{locality.name}}">
                            {{ locality.name }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="flex flex-column w-11 m-0" *ngIf="filterType === 'escorts'">
        <h3 class="w-11 m-0">
            Categorías de Putas en Colombia
        </h3>
        <div class="flex flex-row flex-wrap justify-content-around">
            <div>
                <h4>Por servicio</h4>
                <ul>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('baratas')" class="link" title="Escorts Baratas / Económicas">
                            Escorts Baratas / Económicas
                        </a>
                    </li>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('a-domicilio')" class="link" title="Escorts a Domicilio">
                            Escorts a Domicilio
                        </a>
                    </li>
                </ul>
            </div>
            <div>
                <h4>Por edad</h4>
                <ul>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('maduras')" class="link" title="Escorts Maduras">
                            Escorts Maduras
                        </a>
                    </li>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('universitarias')" class="link" title="Escorts Universitarias">
                            Escorts Universitarias
                        </a>
                    </li>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('18-anos')" class="link" title="Escorts 18 años">
                            Escorts 18 años
                        </a>
                    </li>
                </ul>
            </div>
            <div>
                <h4>Por características</h4>
                <ul>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('tetonas')" class="link" title="Escorts Tetonas">
                            Escorts Tetonas
                        </a>
                    </li>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('gorditas')" class="link" title="Escorts Gorditas">
                            Escorts Gorditas
                        </a>
                    </li>
                    <li class="my-3">
                        <a [routerLink]="getCategoryUrl('morenas')" class="link" title="Escorts Morenas">
                            Escorts Morenas
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <h3 *ngIf="pageTexts && pageTexts['thirdTitle']" class="w-11 m-0">
        {{ pageTexts['thirdTitle'] }}
    </h3>
    <p *ngIf="pageTexts && pageTexts['thirdText']" class="w-11 text-justify m-1" style="white-space: pre-wrap;">
        {{ pageTexts['thirdText'] }}
    </p>
    <h2 *ngIf="pageTexts && pageTexts['fourthTitle']" class="w-11 m-0">
        {{ pageTexts['fourthTitle'] }}
    </h2>
    <p *ngIf="pageTexts && pageTexts['fourthText']" class="w-11 text-justify m-1" style="white-space: pre-wrap;">
        {{ pageTexts['fourthText'] }}
    </p>
    <h2 *ngIf="pageTexts && pageTexts['fifthTitle']" class="w-11 m-0">
        {{ pageTexts['fifthTitle'] }}
    </h2>
    <p *ngIf="pageTexts && pageTexts['fifthTitle']" class="w-11 text-justify m-1" style="white-space: pre-wrap;">
        {{ pageTexts['fifthText'] }}
    </p>
    <h3 *ngIf="pageTexts && pageTexts['sixthTitle']" class="w-11 m-0">
        {{ pageTexts['sixthTitle'] }}
    </h3>
    <p *ngIf="pageTexts && pageTexts['sixthTitle']" class="w-11 text-justify m-1" style="white-space: pre-wrap;">
        {{ pageTexts['sixthText'] }}
    </p>
    <h3 *ngIf="pageTexts && pageTexts['seventhTitle']" class="w-11 m-0">
        {{ pageTexts['seventhTitle'] }}
    </h3>
    <p *ngIf="pageTexts && pageTexts['seventhTitle']" class="w-11 text-justify m-1" style="white-space: pre-wrap;">
        {{ pageTexts['seventhText'] }}
    </p>
    <h2 *ngIf="pageTexts && pageTexts['eighthTitle']" class="w-11 m-0">
        {{ pageTexts['eighthTitle'] }}
    </h2>
    <p *ngIf="pageTexts && pageTexts['eighthTitle']" class="w-11 text-justify m-1 mb-3" style="white-space: pre-wrap;">
        {{ pageTexts['eighthText'] }}
    </p>
    <div *ngIf="currentCity && !locality && currentCity.searchName !== 'cali'" class="w-11">
        <h3 class="w-11 m-0">
            Todas las ubicaciones de Escorts en {{ currentCity.name }} 🗺️
        </h3>
        <div class="w-10 align-items-center m-auto">
            <ul class="listado">
                <li *ngFor="let locality of localitiesList" class="my-3">
                    <a [routerLink]="getLocalityUrl(locality)" class="link" title="Escorts en {{locality.name}}">
                        {{ locality.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>